import { useState } from 'react'
import PrimaryButton from '../../../global/components/buttons/primary-button/PrimaryButton'
import SecondaryButton from '../../../global/components/buttons/secondary-button/SecondaryButton'
import styles from './styles.module.css'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import { IDeliveryCandidate } from '../../../../../app/entities/DeliveryCandidate'
import PrimaryCheckbox from '../../../global/components/checkbox/Checkbox'

interface IProps {
  isOpen: boolean
  deliveryCandidate: IDeliveryCandidate | null
  handleClose: () => void
  handleConfirm: () => Promise<void>
}

export default function RejectDeliveryCandidateModal(props: IProps) {
  const { isOpen, deliveryCandidate, handleClose, handleConfirm } = props
  const [isChecked, setIsChecked] = useState(false)

  async function handleReject() {
    try {
      await handleConfirm()
      handleClose()
      setIsChecked(false)
    } catch (error) {
      console.error('Failed to reject delivery candidate:', error)
    }
  }

  function handleCancel() {
    setIsChecked(false)
    handleClose()
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleCancel}
    >
      <Box className={styles.scheduleModal}>
        <div className={`${styles.scheduleModalPageTitle} font--bold`}>
          Reject Delivery from Routing
        </div>
        <div style={{ marginBottom: '10px', fontSize: '16px' }}>
          Are you sure you want to reject this delivery candidate from routing?
          This action cannot be undone.
        </div>
        <div
          style={{ marginBottom: '24px', fontWeight: 'bold', fontSize: '16px' }}
        >
          You must manually revert this order to the original shipping method in
          AS400.
        </div>
        {deliveryCandidate && (
          <div style={{ marginBottom: '16px', textAlign: 'center' }}>
            <div>
              <strong>TR Order Number:</strong>{' '}
              {deliveryCandidate.tireRackDeliveryData.tireRackOrderNumber}
            </div>
            <div>
              <strong>Customer:</strong>{' '}
              {deliveryCandidate.tireRackDeliveryData.customerFullName}
            </div>
            <div>
              <strong>Original Shipping Method:</strong>{' '}
              {deliveryCandidate.tireRackDeliveryData.shippingMethod}
            </div>
          </div>
        )}
        <div className={styles.checkBoxContainer}>
          <PrimaryCheckbox
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
          />
          <div>
            Yes, I want to reject this order so that TRMI will not be
            responsible for delivery.
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <SecondaryButton
            buttonName='Cancel'
            onClick={handleCancel}
          />
          <PrimaryButton
            buttonName='Reject'
            disabled={!isChecked}
            onClick={handleReject}
          />
        </div>
      </Box>
    </Modal>
  )
}
